import { createCachedSelector, defaultKeySelector, path, chain, empty, bound } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions, defaultChainSelectorOptions } from '@cbridge-utils/reselect';
import { IFormValues } from '@cbridge-tools/form';
import { detailsSidebarStoreSelector, SidebarOpenMode, detailsSidebarResourceIdSelector } from '@cbridge-packages/details-sidebar';
import { streamSelector, StreamTranslator, IStreamForm } from '@cbridge-packages/stream';
import { selectedNodeSelector } from '@cbridge-packages/node';

const selectedStreamSelector = chain(
  detailsSidebarResourceIdSelector,
  defaultChainSelectorOptions,
)
  .chain((streamId) => {
    if (streamId === undefined) {
      return empty(streamSelector);
    }
    return bound(streamSelector, { streamId });
  })
  .build();

export const streamFormProviderPropsSelector = createCachedSelector(
  [
    path(detailsSidebarStoreSelector).mode(),
    selectedStreamSelector,
    selectedNodeSelector,
  ],
  (mode, stream, nodeId): IFormValues<IStreamForm> => {
    return {
      disabled: mode === SidebarOpenMode.View,
      values: StreamTranslator.toFormData(stream, nodeId),
      defaultValues: mode === SidebarOpenMode.Create
        ? { nodeId }
        : undefined,
    };
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
